import gql from 'graphql-tag'

export const TEST_CHANNEX_CONNECTION_QUERY = gql`
  query TestChannexConnection {
    testChannexConnection {
      ok
      propertyTitle
      error
    }
  }
`
